import React from 'react'
import { TableRow } from '@material-ui/core'
import { StyledTableCell } from '../../commons/utils/TableStyles'

const SafeFeedbackRankingGridRow = (props) => {
	const item = props.item

	return (
		<TableRow>
			<StyledTableCell align="left">{item.posicion}</StyledTableCell>
			<StyledTableCell align="left">{item.conductor}</StyledTableCell>
			<StyledTableCell align="left"><b>{item.puntuacion} pts</b></StyledTableCell>
			<StyledTableCell align="left">{item.total_eventos}</StyledTableCell>
			<StyledTableCell align="left">{item.confirmados}</StyledTableCell>
			<StyledTableCell align="left">{item.desestimados}</StyledTableCell>
			<StyledTableCell align="left">
				<button
					className="action view btn btn-sm btn-icon btn-dt-grid text-success"
					onClick={() => props.onVisualizar(item)}
				>
					<i className="fa fa-search fa-xs" />
				</button>
			</StyledTableCell>
		</TableRow>
	)
}

export default SafeFeedbackRankingGridRow
